import axios from "axios";

class ApiVersionService {
  getApiVibe() {
    return axios.get(`health`);
  }
}

export default new ApiVersionService();
